import React from 'react';

const Planet1 = ({ className = '' }) => {
  return (
    <svg
      id="Calque_12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 789.57 619.87"
      className={className}
    >
      <defs>
        <style>{`.cls-1{fill:#fdf9f5;}.cls-2{fill:#815e40;}.cls-3{fill:#866240;}.cls-4{fill:#8b5f34;}.cls-5{fill:#9d744a;}.cls-6{fill:#c37c36;}.cls-7{fill:#8e6743;}.cls-8{fill:#b37745;}.cls-9{fill:#ca9a63;}.cls-10{fill:#8a5f37;}.cls-11{fill:#8a6542;}.cls-12{fill:#704b29;}.cls-13{fill:#846040;}.cls-14{fill:#714c29;}`}</style>
      </defs>
      <path
        className="cls-5"
        d="M399.54,42.95c9.28,.13,18.42,.63,27.48,1.52-53.57-7.09-109.15,.54-158.73,23.75-1.89,.95-3.7,1.98-5.57,2.96,39.08-19.17,83.02-28.29,126.68-28.23,3.35,0,6.69,0,10.14,0Z"
      />
      <path
        className="cls-5"
        d="M157.92,173.55c3.07,1.12,6.15,2.24,9.32,3.4,3.05,1.11,6.1,2.23,9.24,3.37,15.55,5.6,28.35,6.32,44.74,5.97,5.5-.07,10.99-.14,16.49-.2,8.64-.11,17.28-.25,25.92-.43,8.36-.17,16.71-.26,25.07-.34,2.55-.07,5.1-.15,7.73-.22,19.73-.09,36.4,4.42,51.02,18.29,12.99,14.95,14.86,27.34,14.56,46.46-1.52,14.12-7.99,21.76-18.45,30.85-16.35,11.88-30.67,14.01-50.44,10.91-10.5-2.74-20.73-5.88-31-9.37-39.58-12.92-80.42-10.3-117.36,8.12-7.63,3.51-14.52,5.29-21.8,6.28v1.16h-15.47c-1.02,14.29-2.04,28.59-3.09,43.31h-2.68c.36,2.69,.71,5.37,1.08,8.13,2.98,21.34,7.25,40.97,13.02,59.81,.25-.76,.47-1.45,.96-2.97v6.06c.27,.86,.53,1.74,.81,2.6,3.11-2.39,3.44-2.64,7.14-5.49,30-22.54,64.94-46.49,103.89-47.02q3.75-.06,7.58-.13c2.68-.03,5.36-.06,8.12-.1,5.74-.1,11.48-.2,17.22-.31,9-.15,18-.28,27-.41,8.72-.12,17.44-.28,26.16-.45,2.64-.03,5.29-.05,8.01-.08,42.38-.85,75.53-13.33,109.62-38.22,2.48-1.77,4.96-3.53,7.52-5.35,10.01-8.84,16.98-18.74,24.58-29.64,29.39-40.91,59.84-65.05,110.21-76.38,8.89-.94,17.74-1.51,26.66-2.02,11.15-1.63,17.21-6.52,25.93-13.45h6.19l-6.19-18.56c.25,.22,.47,.44,.72,.66-9.05-16.15-13.04-20.99-30.99-42.79-1.03-1.17-1.75-2.01-2.3-2.75-9.18-9.58-19.06-18.39-29.31-26.27,.73-.64,1.47-1.19,2.21-1.78-1.76-1.48-3.53-2.96-5.3-4.4-24.22-18.6-51.37-32.78-80.02-42.48,.18,.37,.35,.7,.49,.98,.16,.32,.32,.64,.48,.96,.1,.2,.2,.4,.3,.59,.16,.32,.32,.64,.48,.97,.24,.49,.54,1.07,.93,1.85-8.1,1.75-16,3.15-24.25,3.99-33.79,3.66-61.26,17.02-88.67,36.62-28.02,19.36-63.45,29.62-97.45,27.46-18.31-3.81-35.68-9.68-53.28-15.89q-8.57-3.13-17.87-2.67c4.51-4.3,9.22-8.31,14.02-12.19-28.38,21.67-52.42,47.73-71.87,77.42,1.72-2.17,3.42-4.35,5.25-6.46q3.52,1.29,7.12,2.6Zm248.31,17.51q7.54-4.64,18.56-4.45,10.63,2.9,16.63,6.38c5.43,9.58,4.79,16.72,3.29,27.46-7.48,8.34-12.4,11.78-23.4,13.92-10.4-2.13-13.88-5.2-19.92-13.92-1.75-12.27-1.78-18.81,4.83-29.39Z"
      />
      <path
        className="cls-5"
        d="M101.11,314.97c-.03-2.38-.05-4.77-.08-7.22-.07-16.5-.07-18.32,2.36-23.38,1.67-13.19,4.31-26.21,7.96-38.91-.65,1.75-1.35,3.45-1.98,5.21-8.49,28.53-11.71,58.66-10.24,88.66,.7-.41,1.37-.87,2.08-1.27-.28-7.67-.32-15.38-.11-23.09Z"
      />
      <path
        className="cls-11"
        d="M671.27,316.16c-.25-4.14-.49-8.16-.73-12.18-1.08-19.2-3.59-37.28-9.28-55.69-2.25-1.13-2.89-1.45-4.22-2.11-1.7,1.75-3.4,3.49-5.07,5.2-1.56,1.62-3.12,3.25-4.73,4.92-20.91,21.72-42.59,41.51-66.42,60.04-1.9,1.5-3.8,3.01-5.76,4.55-69.67,55.04-146.08,99.72-226.26,137.76-2.66,1.28-5.31,2.56-8.05,3.87-35.46,17.02-71.21,32.67-108.16,46.21-3.22,1.2-6.44,2.39-9.75,3.62-16.43,5.84-29.83,9.66-47.29,8.17v3.09c15.22,13.5,31.7,25.65,48.34,37.32,64.92,42.26,142.45,58.18,218.76,42.13,2.8-.71,5.52-1.41,8.24-2.1,52.88-12.91,103.66-39.15,141.43-78.72,10.65-11.91,20.38-24.32,29.11-37.18-1.55,1.18-3.57,2.53-6.57,4.53,3.26-13.28,5.43-21.71,15.47-30.94,3.24-6.11,6.36-12.29,9.28-18.56,1.88,5.65,2.61,7.87,2.13,10.57,20.69-40.96,31.49-85.98,29.54-134.51Zm-282.06,291.19c-2.12-.01-4.23-.03-6.41-.04-5.15-.04-10.29-.09-15.44-.15v-3.09c19.72-2.98,38.85-3.42,58.78-3.09v-6.19q5.05-.74,10.2-1.49c30.94-4.8,58.62-11.72,86.32-27.02,1.84-.8,3.68-1.6,5.57-2.43,2.04,1.02,4.08,2.04,6.19,3.09-46.31,25.37-91.56,40.89-145.21,40.41Z"
      />
      <path
        className="cls-9"
        d="M181.13,519.61c20.64-3.75,39.63-9.75,59.2-17.24,3.18-1.21,6.36-2.42,9.64-3.67,60.2-23.27,118.39-49.94,174.46-81.93,7.79-4.45,15.61-8.83,23.44-13.21,75.61-42.64,147.14-95.43,207.21-158.36,.85,.43,1.46,.73,1.97,.99,34.41-35.34,75.03-78.07,76.92-129.18-.97-15.11-4.27-23.53-15.54-33.93-31.46-23.89-74.26-9.77-108.17,1.69-2.44,.84-4.82,1.65-7.19,2.47-13.06,4.45-24.81,8.38-35.49,16.97,8.78,7.37,17.43,15.14,25.67,23.36-.03-.83-.04-1.78-.04-3.02q83.55-31.96,108.28-15.47c-1.46,31.5-13.99,51.43-32.68,75.8-1.49,1.97-2.99,3.94-4.53,5.97-3.87,4.9-8.06,9.55-12.29,14.14h-6.19c-3.4,9.08-8.29,15.27-15.07,22.08-1.76,1.77-3.52,3.54-5.33,5.37-1.88,1.85-3.76,3.71-5.7,5.62-1.95,1.93-3.9,3.86-5.9,5.85-16.34,16-33.43,30.63-51.52,44.62-1.02,.8-1.79,1.41-2.47,1.95-1.05,.83-2.11,1.67-3.17,2.5-.05,.04-.11,.09-.17,.13-.46,.36-.92,.73-1.39,1.09-.67,.53-1.44,1.13-2.44,1.92-104.59,82-224.08,143.43-349.24,187.31q-3.43,1.2-6.94,2.43c-1.03,.36-2.04,.7-3.01,1.04-27.62,9.52-30.3,10.22-39.79,6.85,.22,1.29,.23,2.75,.23,5.14q-79.42,13.16-108.28-6.19c-8.42-12.63-8.1-22.3-6.19-37.12,10.26-32.26,38.18-57.71,61.87-80.44,.83,.83,1.56,1.65,2.25,2.46-2.29-12.64-3.79-25.44-4.42-38.25-24.01,14.17-43.46,33.46-60.67,55.33-21.98,29.09-35.07,57.93-29.97,94.94,5.44,17.64,16.01,26.87,30.94,37.12,39.83,20.94,94.49,9.53,136.12,0v-6.19c1.84-.31,3.68-.62,5.58-.93Z"
      />
      <path
        className="cls-9"
        d="M196.46,485.85c-1.03,.36-2.04,.7-3.01,1.04,.97-.33,1.97-.68,3.01-1.04Z"
      />
      <path
        className="cls-9"
        d="M112.52,401.82c.78,3.18,1.66,6.32,2.57,9.44,.33-1.02,.53-1.65,.72-2.21-5.77-18.84-10.04-38.47-13.02-59.81-.37-2.77-.72-5.44-1.08-8.13h-.41c-.04-1.01-.05-2.03-.09-3.04-.71,.41-1.38,.86-2.08,1.27,.63,12.82,2.12,25.61,4.42,38.25,6.13,7.28,6.65,13.93,8.97,24.23Z"
      />
      <path
        className="cls-9"
        d="M562.26,288.51c-.81,.64-1.65,1.3-2.47,1.95,.68-.53,1.45-1.14,2.47-1.95Z"
      />
      <path
        className="cls-9"
        d="M555.07,294.18c-.82,.64-1.61,1.27-2.44,1.92,1-.79,1.76-1.39,2.44-1.92Z"
      />
      <path
        className="cls-9"
        d="M117.58,414.73c-.28-.86-.53-1.73-.81-2.6v3.22c.3-.23,.55-.42,.81-.62Z"
      />
      <path
        className="cls-9"
        d="M556.62,292.96c-.06,.04-.11,.09-.17,.13,.06-.04,.11-.09,.17-.13Z"
      />
      <path
        className="cls-9"
        d="M594.66,132.26c-1.04-1.43-1.34-2.52-1.42-4.69-8.24-8.22-16.89-16-25.67-23.36-.74,.59-1.48,1.14-2.21,1.78,10.24,7.88,20.13,16.69,29.31,26.27Z"
      />
      <path
        className="cls-9"
        d="M447.87,403.56c-7.83,4.38-15.65,8.76-23.44,13.21-56.07,31.99-114.26,58.65-174.46,81.93-3.28,1.25-6.46,2.46-9.64,3.67-19.57,7.5-38.55,13.49-59.2,17.24-1.9,.32-3.74,.62-5.58,.93,17.46,1.49,30.86-2.33,47.29-8.17,3.32-1.23,6.53-2.43,9.75-3.62,36.95-13.53,72.7-29.19,108.16-46.21,2.74-1.32,5.39-2.6,8.05-3.87,80.18-38.04,156.59-82.72,226.26-137.76,1.96-1.55,3.86-3.05,5.76-4.55,23.83-18.53,45.52-38.33,66.42-60.04,1.61-1.67,3.17-3.3,4.73-4.92,1.67-1.71,3.36-3.45,5.07-5.2-.51-.26-1.12-.56-1.97-.99-60.06,62.92-131.59,115.72-207.21,158.36Z"
      />
      <path
        className="cls-3"
        d="M150.02,486c.75,1.29,1.31,2.28,1.8,3.17,.7,1.18,1.37,2.35,2.08,3.53,57.36-11.96,110.86-34.51,163.97-58.78,2.74-1.24,5.49-2.48,8.31-3.76,57.29-26,113.63-55.57,164.93-92.15,2.07-1.45,4.13-2.9,6.26-4.39,31.18-21.89,61.09-44.62,89.64-69.85q4.19-3.68,8.47-7.43c16.33-14.49,31.97-29.53,47.22-45.16-2.11-7.08-4.77-14-7.83-20.76-2.68-4.95-4.93-9.06-6.92-12.61-.25-.22-.46-.44-.72-.66l6.19,18.56h-6.19c-8.72,6.93-14.78,11.82-25.93,13.45-8.92,.51-17.77,1.08-26.66,2.02-50.37,11.32-80.83,35.47-110.21,76.38-7.6,10.91-14.57,20.81-24.58,29.64-2.56,1.82-5.04,3.59-7.52,5.35-34.1,24.89-67.24,37.37-109.62,38.22-2.72,.03-5.37,.05-8.01,.08-8.72,.16-17.44,.32-26.16,.45-9,.12-18,.26-27,.41-5.74,.1-11.48,.21-17.22,.31-2.76,.03-5.44,.07-8.12,.1q-3.83,.06-7.58,.13c-38.95,.52-73.89,24.47-103.89,47.02-3.7,2.85-4.03,3.1-7.14,5.49,7.59,23.3,17.63,45.49,30.64,68.27,.6,1,1.19,2,1.8,3Z"
      />
      <path
        className="cls-3"
        d="M116.77,406.07c-.49,1.52-.72,2.21-.96,2.97,.32,1.03,.64,2.06,.96,3.09v-6.06Z"
      />
      <path
        className="cls-3"
        d="M645.79,204.98c-3.44,9.06-8.29,15.26-15.07,22.08,6.78-6.81,11.67-13,15.07-22.08Z"
      />
      <path
        className="cls-3"
        d="M153.66,493.72s0,.01,0,.02c9.48,3.36,12.17,2.67,39.79-6.85-27.54,9.49-30.19,10.18-39.79,6.83Z"
      />
      <path
        className="cls-3"
        d="M556.46,293.09c-.41,.32-.87,.69-1.39,1.09,.46-.37,.92-.73,1.39-1.09Z"
      />
      <path
        className="cls-3"
        d="M559.8,290.46c-1.28,1.01-2.14,1.69-3.17,2.5,1.06-.83,2.12-1.67,3.17-2.5Z"
      />
      <path
        className="cls-3"
        d="M117.58,414.73c-.26,.2-.5,.39-.81,.62v-3.22c-.33-1.03-.65-2.06-.96-3.09-.18,.56-.39,1.19-.72,2.21,7.45,25.47,19.31,48.97,33.13,71.75-13.01-22.78-23.05-44.97-30.64-68.27Z"
      />
      <path
        className="cls-3"
        d="M637.37,195.02c-.88-1.63-1.71-3.15-2.5-4.62,3.06,6.76,5.72,13.68,7.83,20.76-15.24,15.63-30.89,30.67-47.22,45.16q-4.28,3.75-8.47,7.43c-28.55,25.23-58.46,47.96-89.64,69.85-2.13,1.49-4.2,2.94-6.26,4.39-51.3,36.58-107.65,66.15-164.93,92.15-2.83,1.28-5.57,2.52-8.31,3.76-53.11,24.27-106.61,46.83-163.97,58.78-.71-1.18-1.38-2.35-2.08-3.53,1.06,1.92,1.6,3.16,1.84,4.55,9.6,3.34,12.25,2.66,39.79-6.83,.97-.33,1.97-.68,3.01-1.04q3.5-1.23,6.94-2.43c125.16-43.88,244.65-105.32,349.24-187.31,.83-.65,1.62-1.28,2.44-1.92,.51-.4,.98-.77,1.39-1.09,.06-.04,.11-.09,.17,.13,1.03-.81,1.89-1.49,3.17-2.5,.82-.64,1.65-1.3,2.47-1.95,18.09-13.99,35.19-28.62,51.52-44.62,2.01-1.99,3.95-3.92,5.9-5.85,1.94-1.91,3.82-3.76,5.7-5.62,1.81-1.83,3.57-3.6,5.33-5.37,6.78-6.81,11.62-13.02,15.07-22.08h-3.09c-1.76-3.29-3.52-6.57-5.33-9.96Z"
      />
      <path
        className="cls-13"
        d="M111.35,245.46c9.04-24.31,20.46-47.09,34.19-68.05-16.15,20.43-27.16,43.59-34.19,68.05Z"
      />
      <path
        className="cls-13"
        d="M101.11,315.2c0-.07,0-.15,0-.22-.22,7.72-.17,15.43,.11,23.09,.02-.01,.04-.03,.07-.04-.07-7.61-.13-15.22-.17-22.83Z"
      />
      <path
        className="cls-13"
        d="M104.4,282.32c1.02,4.08,2.04,8.17,3.09,12.37h15.47v1.94c7.28-.98,14.17-2.76,21.8-6.28,36.93-18.42,77.78-21.04,117.36-8.12,10.27,3.49,20.5,6.63,31,9.37,19.77,3.1,34.1,.97,50.44-10.91,10.46-9.09,16.93-16.73,18.45-30.85,.31-19.11-1.56-31.51-14.56-46.46-14.63-13.87-31.29-18.37-51.02-18.29-2.63,.08-5.18,.15-7.73,.22-8.36,.08-16.71,.17-25.07,.34-8.64,.18-17.28,.32-25.92,.43-5.5,.06-10.99,.13-16.49,.2-16.39,.35-29.18-.37-44.74-5.97-3.14-1.15-6.19-2.26-9.24-3.37-3.17-1.15-6.24-2.28-9.32-3.4q-3.59-1.31-7.12-2.6c-1.83,2.11-3.54,4.28-5.25,6.46-13.73,20.96-25.15,43.74-34.19,68.05-3.65,12.7-6.29,25.72-7.96,38.91,.3-.62,.63-1.29,1.01-2.04Z"
      />
      <path
        className="cls-13"
        d="M101.21,338.07c.04,1.01,.04,2.03,.09,3.04,0-1.03-.01-2.05-.02-3.08-.02,.01-.04,.03-.07,.04Z"
      />
      <path
        className="cls-7"
        d="M217.42,99.98c14.04-10.72,29.17-20.33,45.3-28.8-16.05,7.87-31.26,17.46-45.3,28.8Z"
      />
      <path
        className="cls-7"
        d="M481.83,56.48c-17.98-6.55-36.19-10.19-54.81-12.02,16.81,2.22,33.42,5.87,49.58,10.97,1.79,.28,3.12,.58,5.22,1.05Z"
      />
      <path
        className="cls-7"
        d="M221.27,114.84c17.61,6.21,34.98,12.08,53.28,15.89,34,2.17,69.43-8.1,97.45-27.46,27.41-19.59,54.87-32.95,88.67-36.62,8.25-.84,16.15-2.23,24.25-3.99-11.23,1.02-22.46,2.04-34.03,3.09,2.04-1.02,4.08-2.04,6.19-3.09v-9.28c12.03,1.15,16.45,1.57,19.53,2.05-16.16-5.1-32.78-8.75-49.58-10.97-9.06-.89-18.2-1.39-27.48-1.52-3.45,0-6.79,0-10.14,0-43.66-.06-87.6,9.06-126.68,28.23-16.13,8.47-31.26,18.09-45.3,28.8-4.8,3.88-9.51,7.89-14.02,12.19q9.3-.46,17.87,2.67Z"
      />
      <path className="cls-7" d="M483.22,59.26l.3,.59c-.1-.2-.2-.4-.3-.59Z" />
      <path
        className="cls-1"
        d="M143.83,482.44c-.44-.79-.77-1.39-1.05-1.88-1.96-3.2-3.84-6.45-5.71-9.9-1.22-2.21-2.43-4.43-3.69-6.71-1.42-2.66-2.78-5.35-4.11-8.06-13.32-24.41-16.01-30.05-15.36-37.58-4.39-13.27-7.86-26.9-10.37-40.71-.68-.81-1.41-1.63-2.25-2.46-23.7,22.73-51.61,48.18-61.87,80.44-1.91,14.82-2.23,24.5,6.19,37.12q28.86,19.35,108.28,6.19c0-2.39,0-3.86-.23-5.14-.89-.31-1.83-.66-2.86-1.04q-3.81-4.5-6.97-10.26Z"
      />
      <path
        className="cls-1"
        d="M115,411.54c.03-.11,.06-.18,.09-.28-.91-3.12-1.8-6.26-2.57-9.44-2.32-10.29-2.84-16.95-8.97-24.23,2.51,13.81,5.98,27.44,10.37,40.71,.17-1.99,.58-4.12,1.08-6.76Z"
      />
      <path
        className="cls-1"
        d="M136.69,469.3c-1.19-2.14-2.39-4.28-3.62-6.48-1.35-2.47-2.61-4.77-3.79-6.93,1.33,2.71,2.69,5.4,4.11,8.06,1.25,2.28,2.47,4.49,3.69,6.71,1.86,3.45,3.75,6.7,5.71,9.9-.83-1.49-1.16-2.09-2.51-4.52-1.18-2.22-2.36-4.45-3.58-6.74Z"
      />
      <path
        className="cls-1"
        d="M148.22,483c1.17,2.05,2.38,4.1,3.6,6.16-.49-.88-1.05-1.88-1.8-3.17-.61-.99-1.19-2-1.8-3Z"
      />
      <path
        className="cls-1"
        d="M129.28,455.88c-5.95-12.08-11.09-24.66-15.36-37.58-.65,7.53,2.04,13.17,15.36,37.58Z"
      />
      <path
        className="cls-1"
        d="M143.83,482.44q3.16,5.76,6.97,10.26c-2.91-4.1-5.53-8.07-8.02-12.14,.28,.5,.61,1.09,1.05,1.88Z"
      />
      <path
        className="cls-1"
        d="M150.8,492.7c1.03,.38,1.98,.73,2.86,1.04,0,0,0-.01,0-.02-.89-.31-1.83-.65-2.86-1.02Z"
      />
      <path
        className="cls-1"
        d="M113.92,418.3c4.27,12.92,9.41,25.5,15.36,37.58,1.18,2.16,2.44,4.46,3.79,6.93,1.23,2.2,2.43,4.34,3.62,6.48,1.22,2.29,2.4,4.51,3.58,6.74,1.35,2.42,1.68,3.03,2.51,4.52,2.49,4.07,5.11,8.05,8.02,12.14,1.03,.37,1.97,.71,2.86,1.02-.25-1.39-.78-2.63-1.84-4.55-1.22-2.06-2.43-4.12-3.6-6.16-13.82-22.77-25.67-46.28-33.13-71.75-.03,.1-.06,.18-.09,.28-.51,2.64-.91,4.77-1.08,6.76Z"
      />
      <path
        className="cls-1"
        d="M594.66,132.26c.54,.74,1.27,1.58,2.3,2.75,17.95,21.8,21.93,26.64,30.99,42.79,.42,.37,.81,.74,1.21,1.11-9.19-16.95-21.06-32.64-34.49-46.65Z"
      />
      <path
        className="cls-1"
        d="M645.79,204.98h6.19c4.23-4.6,8.42-9.24,12.29-14.14,1.54-2.03,3.04-4,4.53-5.97,18.69-24.36,31.22-44.3,32.68-75.8q-24.73-16.49-108.28,15.47c0,1.24,0,2.19,.04,3.02,22.37,22.31,41.75,47.88,52.55,77.42Z"
      />
      <path
        className="cls-1"
        d="M629.16,178.91c7.98,7.44,12.58,15.62,16.64,26.07-10.81-29.54-30.19-55.11-52.55-77.42,.08,2.17,.38,3.26,1.42,4.69,13.43,14.01,25.31,29.7,34.49,46.65Z"
      />
      <path
        className="cls-1"
        d="M629.16,178.91c-.4-.37-.79-.74-1.21-1.11,1.99,3.55,4.24,7.67,6.92,12.61-1.76-3.89-3.67-7.73-5.71-11.5Z"
      />
      <path
        className="cls-1"
        d="M629.16,178.91c2.04,3.77,3.95,7.61,5.71,11.5,.8,1.47,1.62,2.99,2.5,4.62,1.81,3.39,3.57,6.67,5.33,9.96h3.09c-4.06-10.46-8.66-18.64-16.64-26.07Z"
      />
      <path
        className="cls-8"
        d="M81.58,150.26c12.14-1.12,14.69-2.12,23.2-10.63,7.33-11.23,7.72-17.37,5.8-30.55q-4.83-7.35-12.37-12.37c-21.54-4.83-32.15-1.13-43.31,18.56-.21,12.34,1.29,18.95,8.12,29.2q7.35,4.83,18.56,5.8Z"
      />
      <path
        className="cls-6"
        d="M750.98,341.11c-18.92-2.06-30.4-.55-37.32,18.18q.19,9.67,6.57,18.56,9.09,6.57,18.56,8.12c10.38-1.77,14.78-2.61,21.46-10.83,1.58-8.52,1.42-16.21,0-24.75q-3.29-6.19-9.28-9.28Z"
      />
      <path
        className="cls-2"
        d="M421.31,234.37c11-2.15,15.91-5.58,23.4-13.92,1.51-10.74,2.14-17.87-3.29-27.46q-5.99-3.48-16.63-6.38-11.02-.19-18.56,4.45c-6.62,10.58-6.59,17.12-4.83,29.39,6.04,8.72,9.51,11.79,19.92,13.92Z"
      />
      <path
        className="cls-14"
        d="M522.66,566.28c-27.7,15.3-55.38,22.22-86.32,27.02q-5.15,.75-10.2,1.49v6.19c-19.93-.33-39.06,.12-58.78,3.09v3.09c5.15,.06,10.29,.11,15.44,.15,2.18,.01,4.3,.03,6.41,.04,53.65,.47,98.9-15.04,145.21-40.41-2.1-1.05-4.15-2.07-6.19-3.09-1.89,.83-3.73,1.63-5.57,2.43Z"
      />
      <path className="cls-4" d="M122.96,297.79v-1.16c-4.87,.66-9.9,.96-15.47,1.16h15.47Z" />
      <path
        className="cls-4"
        d="M101.03,307.75c.03,2.46,.05,4.84,.08,7.22,.29-10.22,1-20.46,2.28-30.6-2.43,5.06-2.43,6.88-2.36,23.38Z"
      />
      <path
        className="cls-4"
        d="M107.49,297.79c5.57-.19,10.6-.5,15.47-1.16v-1.94h-15.47c-1.05-4.21-2.07-8.29-3.09-12.37-.38,.76-.71,1.42-1.01,2.04-1.29,10.15-2,20.38-2.28,30.6,0,.07,0,.15,0,.22,.04,7.61,.1,15.22,.17,22.83,0,0,.02,0,.02-.01,.14,1.02,.27,2.07,.41,3.09h2.68c1.05-14.73,2.07-29.02,3.09-43.31Z"
      />
      <path
        className="cls-4"
        d="M101.28,338.03c0,1.03,.01,2.05,.02,3.08h.41c-.14-1.02-.27-2.07-.41-3.09,0,0-.02,0-.02,.01Z"
      />
      <path
        className="cls-12"
        d="M629.21,475.69q2.51-4.6,4.98-9.1c1.73-3.09,3.4-6.08,5.08-9.08,1.34-3.18,2.15-5.11,2.46-6.84-5.97,11.81-12.76,23.28-20.3,34.4,3.23-2.46,4.35-4.15,7.78-9.38Z"
      />
      <path
        className="cls-12"
        d="M639.61,440.1c-2.93,6.27-6.04,12.45-9.28,18.56-10.03,9.23-12.21,17.66-15.47,30.94,3-2,5.03-3.35,6.57-4.53,7.55-11.12,14.34-22.59,20.3-34.4,.49-2.7-.24-4.91-2.13-10.57Z"
      />
      <path className="cls-10" d="M483.51,59.85c.15,.3,.3,.6,.48,.97-.16-.32-.32-.64-.48-.97Z" />
      <path className="cls-10" d="M482.74,58.3c.18,.36,.33,.66,.48,.96-.16-.32-.32-.64-.48-.96Z" />
      <path
        className="cls-10"
        d="M482.25,57.32c-.13-.26-.26-.52-.42-.84-2.1-.47-3.44-.77-5.22-1.05,1.89,.6,3.76,1.25,5.64,1.88Z"
      />
      <path
        className="cls-10"
        d="M457.08,53.39v9.28c-2.1,1.05-4.15,2.07-6.19,3.09,11.57-1.05,22.8-2.07,34.03-3.09-.39-.78-.68-1.37-.93-1.85-.18-.37-.34-.67-.48-.97l-.3-.59c-.15-.29-.3-.6-.48-.96-.14-.28-.31-.62-.49-.98-1.88-.64-3.75-1.29-5.64-1.88-3.07-.48-7.49-.9-19.53-2.05Z"
      />
    </svg>
  );
};
export default Planet1;
